/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserBasicModel { 
    id: number;
    phone: string;
    firstname?: string;
    lastname?: string;
    patronymic?: string;
    asteriskId?: string;
    active: boolean;
    fullname: string;
}

